import { Paragraph } from 'grommet'
import styled, { keyframes, css } from 'styled-components'

const contentAnimation = keyframes`
    0% { transform: translateX( -50% ) rotate( 0deg ); }
    100% { transform: translateX( -50% ) rotate( -360deg ); }
`

export const Container = styled.div`
  background: white;
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
  height: 35px;
  overflow: hidden;
  position: relative;
  top: 0;
  width: 35px;

  ${({ theme }) => css`
    left: ${theme.newSpaces.xs}px;

    ${theme.below.tablet`
      height: 25px;
      width: 25px;
    `}

    ${theme.below.mobileXL`
      height: 20px;
      width: 20px;
      margin-right: 10px;
    `}
  `}

  ${({ centraized }) =>
    centraized
      ? css`
          margin: auto;
          position: initial;
        `
      : ''}
`

export const Border = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
  height: 30px;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  ${({ theme }) => theme.below.tabletM`
    height: 20px;
    width: 20px;
  `}

  ${({ theme }) => theme.below.mobileXL`
    height: 15px;
    width: 15px;
  `}
`

export const Content = styled.div`
  animation: ${contentAnimation} 2s infinite linear;
  background: ${({ theme }) => theme.colors.secondary};
  height: 100%;
  left: 50%;
  position: absolute;
  top: 50%;
  transform-origin: center top;
  width: 150%;
`

export const Text = styled(Paragraph)`
  &:hover {
    box-shadow: none;

    &:after {
      background: ${({ theme }) => theme.newColors.white};
      content: '';
      display: block;
      height: 2px;
      width: 100%;
    }
  }
`
